import { useEffect, useState } from "react";
import { shopid, imagePrefix } from "../../../utils/url";
import bannerApi  from "../../../../node_modules/shops-query/src/modules/banner/index.js"

import fallBackImage from "../../../assets/bannerFallBack.png";
import { Link } from "react-router-dom";

const BannerSection = () => {
  const [bannerData, setBannerData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const bannerImages = async () => {
      const { fetchBanner } = bannerApi;
      try {
        const bannerRes = await fetchBanner({ shopId: shopid });
        setBannerData(bannerRes && bannerRes.length ? bannerRes : [fallBackImage]);
      } catch (error) {
        console.error("Error fetching banner:", error);
        setBannerData([fallBackImage]);
      }
    };
    bannerImages();
  }, []);

  useEffect(() => {
    if (bannerData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === bannerData.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [bannerData]);

  const getImageUrl = (banner) => {
    if (typeof banner === "string") return banner; // fallback string image
    return banner.image ? `${imagePrefix}${banner.image}` : fallBackImage;
  };


  return (
    <div className="relative w-full overflow-x-hidden font-poppins">
        <div className="relative h-[350px] sm:h-[400px] md:h-[500px] lg:h-[700px] xl:h-[700px]">
          {bannerData.map((banner, index) => (
            <img
              key={index}
              src={getImageUrl(banner)}
              alt={`Banner ${index + 1}`}
              className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${index === currentIndex ? "opacity-100" : "opacity-0"
                }`}
            />
          ))}

          {/* Desktop Text Overlay */}
          <div className="hidden sm:block absolute z-10 top-[40%] left-[6%] text-left">
            <p className="w-[35rem] font-bold text-[40px] leading-[44px] uppercase text-neutral-black sm:-ml-7">
              {bannerData[currentIndex]?.title}
            </p>

            <div className="mt-[24px] h-[51px] w-[196px] bg-primary-default flex items-center justify-center rounded-[4px] cursor-pointer sm:-ml-6">
              <Link to="/all-products">
                <p className="text-white font-semibold text-[18px] uppercase">
                  Shop Now
                </p>
              </Link>
            </div>
          </div>

          {/* Dots — Desktop Only */}
          {bannerData.length > 1 && (
            <div className="hidden sm:flex absolute bottom-4 left-1/2 -translate-x-1/2 gap-2 z-20">
              {bannerData.map((_, index) => (
                <span
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full cursor-pointer transition-all border  ${index === currentIndex
                    ? "bg-primary-darker"
                    : "border-black"
                    }`}
                ></span>
              ))}
            </div>
          )}
        </div>
      

      {/* Mobile Text Section */}
      {bannerData.length > 0 && (
        <div className="block sm:hidden bg-[#F4F4F4] text-center px-6 pt-6 pb-10">
          <p className="font-extrabold text-[20px] leading-[24px] uppercase text-neutral-black mt-[31px]">
            {bannerData[currentIndex]?.title}
          </p>

          <div className="mt-6 h-[48px] w-[160px] mx-auto bg-primary-default flex items-center justify-center rounded-[4px] cursor-pointer">
            <Link to="/all-products">
              <p className="text-white font-semibold text-[16px] uppercase">
                Shop Now
              </p>
            </Link>
          </div>

          {/* Dots — Mobile */}
          {bannerData.length > 1 && (
            <div className="flex justify-center mt-6 gap-2">
              {bannerData.map((_, index) => (
                <span
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full cursor-pointer transition-all border ${index === currentIndex
                    ? "bg-primary-darker"
                    : "border-black"
                    }`}
                ></span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BannerSection;
